
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React from 'react';
export default function SpeedPrivacySection() {
    const cryptoIcons = {
        left: [
            { name: 'Ton', icon: '/images/crypto-icons/currency.svg', position: 'row2-1' },
            { name: 'Polygon', icon: '/images/crypto-icons/polygon.svg', position: 'row1-1' },
            { name: 'Tron', icon: '/images/crypto-icons/tron.svg', position: 'row2-2' },
            { name: 'Cardano', icon: '/images/crypto-icons/cardano.svg', position: 'row1-2' },
            { name: 'XRP', icon: '/images/crypto-icons/xrp.svg', position: 'row2-3' },
            { name: 'USDT', icon: '/images/crypto-icons/usdt.svg', position: 'row1-3' },
            { name: 'Bitcoin', icon: '/images/crypto-icons/bitcoin.svg', position: 'row2-4' }
        ],
        right: [
            { name: 'Ethereum', icon: '/images/crypto-icons/ethereum.svg', position: 'row2-5' },
            { name: 'BNB', icon: '/images/crypto-icons/bnb.svg', position: 'row1-4' },
            { name: 'Solana', icon: '/images/crypto-icons/solana.svg', position: 'row2-6' },
            { name: 'Chainlink', icon: '/images/crypto-icons/chainlink.svg', position: 'row2-8' },
            { name: 'Avalanche', icon: '/images/crypto-icons/avalanche.svg', position: 'row2-7' },
            { name: 'Litecoin', icon: '/images/crypto-icons/litecoin.svg', position: 'row1-5' },
            { name: 'Polkadot', icon: '/images/crypto-icons/polkadot.svg', position: 'row1-6' }
        ]
    };
    return (<section className={'speed_section'}>
            <div className={'speed_section_video'}>
                <video autoPlay loop muted playsInline className={'video'}>
                    <source src="/videos/unicorn-1764788017433.mp4" type="video/mp4"/>
                </video>
            </div>
            <div className="container">
                <div className="speed_section_top">
                    <h2>Ultra-fast execution. On-chain privacy.</h2>
                    <p>Proven at scale with 500,000+ trades and execution speeds under 2 milliseconds—your data stays private by design.</p>
                </div>
            </div>
            <div className="speed_section_content">
                <div className="container">
                    <div className="content_wrapper">
                        <ul className={'icons_list left'}>
                            {cryptoIcons.left.map((el, i) => {
            return <li key={el.name} className={'icon_item'}>
                                    <div className={'icon_item_wrapper'}>
                                        <img src={el.icon} alt={el.name} className={'icon_item_icon'} width={34} height={34}/>
                                    </div>
                                </li>;
        })}
                        </ul>
                        <ul className={'icons_list right'}>
                            {cryptoIcons.right.map((el, i) => {
            return <li key={el.name} className={'icon_item'}>
                                    <div className={'icon_item_wrapper'}>
                                        <img src={el.icon} alt={el.name} width={34} height={34} className={'icon_item_icon'}/>
                                    </div>
                                </li>;
        })}
                        </ul>
                    </div>
                </div>
            </div>
        </section>);
}

    async function __Next_Translate__getStaticProps__1a17ab3f3bd__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: 'components//SpeedPrivacySection',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a17ab3f3bd__ as getStaticProps }
  